import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    state = 0,
    count = 100,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.getMyTables, {
        state,
        count,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
